/**
 * Types for the care-plan frequency pipeline:
 * API rows -> role-group accumulator -> rgHash.frequencies -> UI grid rows.
 */

/** Legacy 0/1 flags used across CPF widgets and print. */

/** Scheduler/API care-plan frequency row (enriched in place during processing). */

/** Ranged or default CPF API payload. */

/** Historical or future row shown under a role group's primary plan. */

/** Temporary slot before the primary plan for a role group is chosen. */

/** Primary plan row stored on rgHash.frequencies[id]. */

/** One primary plan per roleGroupId while processing API rows. */

/** Role groups keyed by id, each holding frequencies keyed by care-plan id. */

/** Dummy row seeded by hashRoleGroupList for empty role groups. */

/** Props read by processRoleGroups (print mode overrides timeline flags). */
export const hasPrimaryEffectiveDate = slot => !!slot.effectiveDate && slot.effectiveDate !== '';
export const isProcessedRoleGroupCarePlan = plan => hasPrimaryEffectiveDate(plan) && 'id' in plan && plan.id != null;